export default "__VITE_ASSET__6214b287__"